import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "../lib/api";
import BottomNav from "../components/BottomNav";
import Logo from "../components/Logo";
import { MessageCircle } from "lucide-react";

function timeAgo(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60) return "now";
    if (s < 3600) return `${Math.floor(s/60)}m`;
    if (s < 86400) return `${Math.floor(s/3600)}h`;
    return `${Math.floor(s/86400)}d`;
}

export default function Matches() {
    const [matches, setMatches] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/matches");
                setMatches(data);
            } catch {}
            setLoading(false);
        })();
    }, []);

    const withMsg = matches.filter((m) => m.last_message_preview);
    const newMatches = matches.filter((m) => !m.last_message_preview);

    return (
        <div className="min-h-screen pb-20">
            <header className="px-5 pt-5 pb-3 flex items-center justify-between sticky top-0 bg-ink-950/90 backdrop-blur-xl z-40 border-b border-white/5">
                <Logo size="sm" />
                <h1 className="font-display text-xl text-white">MATCHES</h1>
            </header>

            {loading ? (
                <div className="p-10 text-center text-white/50 text-xs uppercase tracking-widest">Loading…</div>
            ) : matches.length === 0 ? (
                <div className="p-10 text-center" data-testid="matches-empty">
                    <MessageCircle className="w-8 h-8 text-smash mx-auto mb-2" />
                    <h2 className="font-display text-2xl text-white">NO MATCHES YET.</h2>
                    <p className="text-sm text-white/60 mt-1">Go smash some cards first.</p>
                </div>
            ) : (
                <>
                    {newMatches.length > 0 && (
                        <div className="px-5 pt-5">
                            <p className="text-[10px] uppercase tracking-[0.25em] text-dash mb-3">New Smashes</p>
                            <div className="flex gap-3 overflow-x-auto no-scrollbar pb-2" data-testid="matches-new-list">
                                {newMatches.map((m) => (
                                    <Link
                                        key={m.match_id}
                                        to={`/chat/${m.match_id}`}
                                        data-testid={`matches-new-${m.match_id}`}
                                        className="shrink-0 w-20"
                                    >
                                        <div className="w-20 h-24 bg-ink-800 border-2 border-smash overflow-hidden">
                                            {m.other_user.photos?.[0] ? (
                                                <img src={fileUrl(m.other_user.photos[0])} alt="" className="w-full h-full object-cover" />
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center font-display text-2xl text-white/30">
                                                    {m.other_user.name?.[0] || "?"}
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-xs text-white mt-1 truncate font-display uppercase">{m.other_user.name}</div>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="px-5 pt-5">
                        <p className="text-[10px] uppercase tracking-[0.25em] text-white/50 mb-2">Conversations</p>
                        {withMsg.length === 0 ? (
                            <p className="text-sm text-white/40 py-4">No messages yet. Say hi to a new smash above.</p>
                        ) : (
                            <div className="divide-y divide-white/5" data-testid="matches-conversations-list">
                                {withMsg.map((m) => (
                                    <Link
                                        key={m.match_id}
                                        to={`/chat/${m.match_id}`}
                                        data-testid={`matches-conv-${m.match_id}`}
                                        className="flex items-center gap-3 py-3 hover:bg-white/5 -mx-5 px-5 transition-colors"
                                    >
                                        <div className="w-14 h-14 bg-ink-800 overflow-hidden shrink-0 border border-white/10">
                                            {m.other_user.photos?.[0] ? (
                                                <img src={fileUrl(m.other_user.photos[0])} alt="" className="w-full h-full object-cover" />
                                            ) : (
                                                <div className="w-full h-full flex items-center justify-center font-display text-xl text-white/30">
                                                    {m.other_user.name?.[0] || "?"}
                                                </div>
                                            )}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <div className="flex items-center justify-between gap-2">
                                                <span className="font-display uppercase text-white truncate">{m.other_user.name}</span>
                                                <span className="text-[10px] text-white/40">{timeAgo(m.last_message_at)}</span>
                                            </div>
                                            <div className="text-xs text-white/60 truncate">{m.last_message_preview}</div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                </>
            )}

            <BottomNav />
        </div>
    );
}
